import { render, staticRenderFns } from "./DdTextBoxPlaceHolderFree.vue?vue&type=template&id=4aa32702&scoped=true&"
import script from "./DdTextBoxPlaceHolderFree.vue?vue&type=script&lang=js&"
export * from "./DdTextBoxPlaceHolderFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa32702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRow,VTextField})
